import * as qs from "qs";

export const parseUrlIntoObject = (url: string) => qs.parse(url, { arrayFormat: "repeat" } as any);

// SO doesn't like it when there are slashes or pluses in a query string, even when they're properly encoded
// so we strip this out
export const sanitizeForUri = (input: string) => input.replace(/[/|\\|+|&|%]/g, "_");